import { css } from "@emotion/core";
import { fade } from "@material-ui/core/styles";

import {
  drawerWidth,
  miniDrawerWidth,
  white,
  forest,
  mint,
  greyDark,
  greyLight,
} from "../../styles/variables";

export const drawer = css`
  .MuiDrawer-paper {
    flex-direction: column;
    width: ${drawerWidth};
    padding: 42px 0;
  }
`;

export const drawerMini = css`
  .MuiDrawer-paper {
    align-items: center;
    width: ${miniDrawerWidth};
    overflow-x: hidden;
  }
`;

export const logo = css`
  height: 40px;
  padding: 6px 0;
  margin-bottom: 62px;
`;

export const list = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .MuiListItem-root {
    padding: 0;
  }
`;

export const listMini = css`
  width: 70%;

  .MuiListItem-root {
    justify-content: center;
  }
`;

export const contact = css`
  margin-top: auto;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
  color: ${greyDark};
  font-weight: 900;

  &:hover {
    color: ${forest};
  }
`;

export const button = css`
  height: 56px;
  padding: 14px;
  text-align: left;

  &:hover {
    background: ${fade(mint, 0.15)};
  }
`;

export const buttonMini = css`
  margin: 0;
  padding: 14px;
  border-radius: 40.5px;
`;

export const buttonList = css`
  width: 100vw;
  margin-left: 5%;
  padding: 14px;
  padding-left: 0;
  border-radius: 40.5px 0 0 40.5px;
  color: ${forest};
  background-color: ${mint};
`;

export const buttonUnselected = css`
  color: ${greyDark};
  background-color: ${white};
  svg *[fill="#008E8E"] {
    fill: ${greyDark};
  }
`;

export const toggler = css`
  width: 75%;
  display: flex;
  justify-content: center;

  .MuiButton-root {
    width: 100%;
    margin: 0;
    padding: 4%;
    color: ${greyLight};
    background-color: ${white};
    border: solid 2px ${greyLight};
    border-radius: 40.5px;

    .MuiListItemText-primary {
      font-size: 12px;
    }

    &:hover {
      color: ${forest};
      background-color: ${mint};
      border-color: ${mint};
      svg g[stroke="#AFAFAF"] {
        stroke: ${forest};
      }
    }
  }
`;

export const togglerMini = css`
  margin-top: auto;
`;

export const icon = css`
  margin: 0 3% 0 7%;
  min-width: 1em;
`;

export const iconMini = css`
  margin: 0;
`;

export const iconReversed = css`
  transform: scaleX(-1);
  -moz-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  -ms-transform: scaleX(-1);
`;
